<template>
<div class="chapter">
<div class="inner_page">
<p class="OT" id="list"><a id="page_xv"></a><a href="#/xhtml/contents#list">List of Figures</a></p>
<p class="Fig-l1"><a href="#/xhtml/chapter001#fig1" id="fig-1">Figure 1</a>. The SEKAP Spectrum of Christian-Muslim Interaction</p>
<p class="Fig-l"><span href="#/xhtml/chapter002#fig2" id="fig-2" title="Link target outside of Sample">Figure 2</span>. The Hermeneutical Emergence and Development of Islamic Jurisprudence (<i>Fiqh</i>)</p>
<p class="Fig-l"><span href="#/xhtml/chapter002#fig3" id="fig-3" title="Link target outside of Sample">Figure 3</span>. The Hermeneutical Emergence and Development of Christian Thought and Praxis</p>
<p class="Fig-l"><span href="#/xhtml/chapter002#fig4" id="fig-4" title="Link target outside of Sample">Figure 4</span>. Interpretation and Misinterpretation</p>
<p class="Fig-l"><span href="#/xhtml/chapter010#fig5" id="fig-5" title="Link target outside of Sample">Figure 5</span>. Mecca and Medina</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter002.vue?0600107b